import { render, staticRenderFns } from "./registerProtocol.vue?vue&type=template&id=fca9a192&scoped=true"
import script from "./registerProtocol.vue?vue&type=script&lang=js"
export * from "./registerProtocol.vue?vue&type=script&lang=js"
import style0 from "./registerProtocol.vue?vue&type=style&index=0&id=fca9a192&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca9a192",
  null
  
)

export default component.exports